import React, { useEffect, useMemo, useState } from 'react';
import HeadTitle from '../../components/HeadTitle';
import CountrySelect from '../../components/country-select/CountrySelect';
import FilterState from '../../components/country-select/FilterState';
import BasicRangeShortcuts from '../../components/date-range-picker/BasicRangeShortcuts';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import LifeExpectancyMap from '../../components/analytics-and-insights/LifeExpectancyMap';
import WorldMap from '../../components/analytics-and-insights/WorldMap';
import MessagingMetrics from '../../components/analytics-and-insights/MessagingMetrics';
import FeatureUsageMetrics from '../../components/analytics-and-insights/FeatureUsageMetrics';
import ConversionMetrics from '../../components/analytics-and-insights/ConversionMetrics';
import RealTimeUsers from '../../components/analytics-and-insights/RealTimeUsers';
import axios from 'axios';
import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import { fetchDailyActiveUsers, fetchUserAnalytics } from '../../api/user';
import { useSelector } from 'react-redux';
import Loader from '../../components/common/Loader/Loader';
import useLoader from '../../hooks/useLoader';
import NewMetricCard from '../dashboard-overview/NewMetricCard';
import { Box } from '@mui/material';
import WeeklyUsers from '../../components/analytics-and-insights/WeeklyUsers';
import MonthlyUsers from '../../components/analytics-and-insights/MonthlyUsers';
import AnalyticsAndInsightsSkeleton from './AnalyticsAndInsightsSkeleton';

let chartDataObject = [
  { name: 'Active', y: 15000, color: '#008E40', percentage: 50.0 },
  { name: 'Inactive', y: 10000, color: '#3353F4', percentage: 33.3 },
  { name: 'Pending', y: 5000, color: '#D55F5A', percentage: 16.7 },
];

const chartDataObject2 = [
  { name: 'Swipes', y: 15000, color: '#008E40', percentage: 50.0 },
  { name: 'Connected', y: 10000, color: '#3353F4', percentage: 33.3 },
];

const dailyActiveObject = [
  {
    id: 1,
    value: '15,000',
    percentage: 10,
    label: 'Daily Active Users',
    description:
      'Number of users actively engaging with the platform each day.',
  },
  {
    id: 2,
    value: '35%',
    percentage: -2,
    label: 'New Users',
    description: 'Percentage of successful matches based on swipes.',
  },
  // {
  //   id: 3,
  //   value: '12 minutes',
  //   percentage: 5, // Positive value
  //   label: 'Average Session Time',
  //   description: 'The average time users spend on the platform.',
  // },
];

export const data = [
  ['Country', 'User'],
  ['Germany', 200],
  ['United States', 300],
  ['Brazil', 400],
  ['Canada', 500],
  ['France', 100],
  ['India', 129],
  ['Australia', 250],
  ['Russia', 350],
  ['China', 600],
  ['Japan', 450],
];

// Dynamically generate regionsData based on 'data'
const regionsData = data.slice(1).map((item) => ({
  name: item[0], // Country name
  users: item[1], // User count
}));

const AnalyticsAndInsights = () => {
  const [components] = useState([
    {
      id: 1,
      imageSrc: '/assets/images/admin-panel/analytics.png',
      text: 'Analytics and Insights ',
      description:
        'Comprehensive insights into subscription plans, payments, and revenue streams.',
    },
  ]);

  const [chartData1, setChartData1] = useState([]);
  const [chartData2, setChartData2] = useState([]);
  const [dailyData, setDailyData] = useState([]);
  const [totalUsers, setTotalUsers] = useState(1000);
  // const { filter } = useSelector((state) => state);
  const filter = useSelector((state) => state.filter);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);
   const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      const data = await fetchUserAnalytics(filter);
      if (data) {
        chartDataObject[0].percentage = data.activePercent;
        chartDataObject[0].y = data.activeCount;
        chartDataObject[1].percentage = data.inactivePercent;
        chartDataObject[1].y = data.inactiveCount;
        chartDataObject[2].percentage = data.pendingPercent;
        chartDataObject[2].y = data.pendingCount;
        chartDataObject2[0].percentage = data.swipesPercent;
        chartDataObject2[0].y = data.swipesCount;
        chartDataObject2[1].percentage = data.connectPercent;
        chartDataObject2[1].y = data.connectCount;
        setTotalUsers(data.totalUsersCount);
        setChartData1(chartDataObject);
        setChartData2(chartDataObject2);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };
  const fetchDailyActiveData = async () => {
    try {
      const data = await fetchDailyActiveUsers(filter);
      if (data) {
        dailyActiveObject[0].value = data.dailyActiveUsersCount;
        dailyActiveObject[1].value = data.newUsersCount;
        setDailyData(dailyActiveObject);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    }
    finally {
      // stopLoading();
    }
  };
//   const fetchDailyActiveData = async () => {
//   try {
//     const data = await fetchDailyActiveUsers(filter);
//     if (data) {
//       dailyActiveObject[0].value = data.dailyActiveUsersCount;
//       dailyActiveObject[1].value = data.newUsersCount;
//       setDailyData(dailyActiveObject);
//     }
//   } catch (err) {
//     console.error('Error fetching data:', err);
//   } finally {
//     setLoading(false);
//   }
// };

  const fetchAllData = async () => {
    try {
      setLoading();
      await Promise.all([fetchData(), fetchDailyActiveData()]);
    } catch (err) {
      console.error('Error fetching data with loader:', err);
    } finally {
      setLoading();
    }
  };

  useEffect(() => {
    // fetchAllData();
  }, [JSON.stringify(filterWithoutUTM)]);


  

   if (loading) return <AnalyticsAndInsightsSkeleton />;
  return (
    <div>
      {/* Dynamically Render Components */}
      {components.map((component) => (
        <HeadTitle
          key={component.id}
          imageSrc={component.imageSrc}
          text={component.text}
          description={component.description}
        />
      ))}

      {/* <SearchFilter isHideUserManagement={false} /> */}

      {/* <div className="row">
        {dailyData.map((item) => (
          <div key={item.id} className="col-md-4 listInsights">
            <div className="p-20 rounded-4 border">
              <div className="font-20 fw-medium text-neutral-900">
                {item.value}
              </div>            
              <div className="font-14 fw-medium text-neutral-900 d-flex align-items-center">
                {item.label === 'Daily Active Users' && (
                  <FiberManualRecordIcon
                    fontSize="small"
                    className="text-success me-2"
                  /> // Add icon only for this label
                )}
                {item.label}
              </div>
              <p className="font-12 fw-medium text-neutral-500 mb-0">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div> */}

      {/* <div className="my-24">
        <h6 className="text-neutral-900">World User Distribution</h6>
        <WorldMap />
      </div> */}
      <div className="my-24">
        {/* <MessagingMetrics /> */}
      </div>
      {/* <div className="d-flex gap-5">
        <div className="w-100 p-20 border rounded-4">
          <FeatureUsageMetrics
            chartData={chartData1}
            totalUsers={totalUsers}
            title="Users"
            subtitle="Interests or hobbies that attract the most engagement."
            chartHeight={300} // Set custom height
          />
        </div>
        <div className="w-100 p-20 border rounded-4">
          {' '}
          <FeatureUsageMetrics
            chartData={chartData2}
            totalUsers={totalUsers}
            title="Swipes/Likes and Connected"
            subtitle="Interests or hobbies that attract the most engagement."
            chartHeight={300} // Set custom height
          />
        </div>
      </div> */}

      <div className="my-24">
        {/* <ConversionMetrics /> */}
        <NewMetricCard />
      </div>
      <div className="">
        <RealTimeUsers titletext="Real Time Users online" />
      </div>
      <Box my={2}>
        <WeeklyUsers titletext="Weekly Users online" />
      </Box>
      <Box my={2}>
        <MonthlyUsers titletext="Monthly Users online " />
      </Box>
    </div>
  );
};

export default AnalyticsAndInsights;
